<template>
	<div class="alert" v-if="isShow" @animationend="onAnimationEnd" :class="{ fadeOut: isFadeOut }">
		<i class="iconfont icon-fankui-weikaifang"></i>
		{{ message }}
	</div>
</template>

<script>
	export default {
		name: 'Alert',
		data() {
			return {
				isShow: false,
				isFadeOut: false, // 控制渐变消失动画
				timer: null
			};
		},
		mounted() {
			this.startTimer()
		},
		methods: {
			startTimer() {
				this.isShow = true;
				// 清除之前的计时器
				if (this.timer) {
					clearTimeout(this.timer);
				}
				
				// 重新开始计时
				this.isFadeOut = false;
				this.timer = setTimeout(() => {
					this.isFadeOut = true  // 3秒后触发消失动画
				}, 3000);
			},
			onAnimationEnd() {
				// 动画结束后，隐藏组件
				if (this.isFadeOut) {
					this.isShow = false
					this.isFadeOut = false
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.alert {
		position: fixed;
		left: 50%;
		top: 7%;
		transform: translate(-50%, -50%);
		background: #fff;
		border-radius: 4px;
		line-height: 48px;
		padding: 0 35px;
		font-size: 14px;
		color: #0d68ff;
		z-index: 9999;
		opacity: 0;
		animation: alert 0.3s ease-in-out forwards;
		box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
	}

	@keyframes alert {
		from {
			transform: translate(-50%, -20px);
		}

		to {
			transform: translate(-50%, 0);
			opacity: 1;
		}
	}

	.fadeOut {
		animation: fadeOutAnimation 0.3s ease-in-out;
		/* 触发动画 */
	}

	@keyframes fadeOutAnimation {
		from {
			transform: translate(-50%, 0);
			opacity: 1;
		}

		to {
			transform: translate(-50%, -20px);
			opacity: 0;
		}
	}

	.iconfont {
		font-size: 14px;
	}
</style>